import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ChecklistTaskTemplate from './ChecklistTasksTemplates';
import { getTaskTemplateManager, getUserProfileWidget, getChecklistTemplate } from '../../selectors/index';
import { getTaskTemplateThunk } from '../../store/actions//taskTemplates';
import { getChecklistTemplateThunk } from '../../store/actions//checklistTemplates';

const mapStateToProps = state => {
  return {
    taskTemplateManager: getTaskTemplateManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    checklistTemplate: getChecklistTemplate(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTaskTemplates: () => getTaskTemplateThunk('WQSP_TASKTEMPLATELIST'),
      getChecklistTemplate: () => getChecklistTemplateThunk('WQSP_CHECKLISTTEMPLATELIST')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTaskTemplate);
